var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDisableTeleconsultIcon = function SvgDisableTeleconsultIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "97px",
    height: "96px",
    viewBox: "0 0 97 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4525E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3D49",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10.0-Telecounselling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.1.2-Telecounsel-/-Queue----disable-Telecounsel",
    transform: "translate(-672, -275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/07.Card/03.Popup/No-subtext",
    transform: "translate(520, 235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(152.597, 40)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 48,
    cy: 48,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E2F2FF",
    opacity: 0.200000003,
    cx: 48,
    cy: 48,
    r: 39.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(28, 28)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chatbubbles",
    mask: "url(#mask-3)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5, 5)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.95822629,23.9485461 C1.95822629,23.9602136 1.95822629,23.9818818 1.94489295,24.0118839 C1.94989295,23.9918825 1.95322629,23.9702143 1.95822629,23.9485461 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3128535,25.0178589 C27.092391,25.0130957 26.8746994,24.9676928 26.6707115,24.8839291 L22.8687485,23.5359383 L22.8406255,23.5245544 C22.7577148,23.4899905 22.6686341,23.4726744 22.5788137,23.4736616 C22.4960208,23.4737529 22.4139181,23.4887229 22.3364201,23.517858 C22.244016,23.5526794 21.4117088,23.8654025 20.5385563,24.1051346 C20.0651524,24.2350453 18.4172779,24.6589292 17.0948269,24.6589292 C13.7147091,24.6589292 10.5542185,23.3598223 8.19657292,21.000671 C5.87015588,18.6883697 4.56548243,15.5413553 4.57335617,12.261164 C4.57335617,11.4149945 4.66450896,10.5712855 4.84524768,9.74464669 C5.43382208,7.024558 6.9926403,4.55022818 9.23444588,2.78036249 C11.534074,0.976368595 14.3729986,-0.00278638818 17.2957056,0 C20.7916634,0 24.0492453,1.33929138 26.4691633,3.76205871 C28.7565013,6.05692428 30.009984,9.07433434 30,12.2578158 C29.9979617,14.6233726 29.2916572,16.9347598 27.9710659,18.8973233 L27.9583436,18.9160733 L27.9087935,18.9830375 C27.8974104,18.9984393 27.8860273,19.0131715 27.8753137,19.0285732 L27.8652698,19.0466536 C27.8386435,19.0919589 27.8145024,19.1386797 27.7929535,19.1866089 L28.8468967,22.9325903 C28.8934959,23.0871311 28.9187282,23.2473226 28.9218914,23.4087062 C28.9224254,23.8356432 28.7530737,24.2452475 28.4512048,24.5471378 C28.1493358,24.849028 27.7397604,25.0183917 27.3128535,25.0178589 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9365084,26.3430806 C17.7965176,26.0707747 17.5450422,25.8728064 17.2474947,25.80067 C16.8604685,25.6982146 16.4091612,25.7156254 16.0643195,25.6901789 C12.8083044,25.4637741 9.74430014,24.0662973 7.43859087,21.756028 C5.38878704,19.7175555 4.056621,17.0683109 3.64265424,14.2071457 C3.54891088,13.5549137 3.54891088,13.3928602 3.54891088,13.3928602 C3.5488272,12.9472956 3.27301729,12.5482881 2.85624444,12.3907964 C2.43947159,12.2333047 1.96873604,12.3502048 1.6740436,12.6843782 L1.6740436,12.6843782 C1.6740436,12.6843782 1.14640239,13.2589316 0.897312878,13.835494 C-0.5207389,17.1030048 -0.245474921,20.858371 1.63386788,23.8841525 C1.8079627,24.1741078 1.8079627,24.3080364 1.76912616,24.6093756 C1.5863266,25.5542415 1.26625997,27.2209822 1.09953071,28.0854909 C0.987124388,28.6563519 1.1920106,29.2433924 1.63520707,29.620312 L1.66600846,29.6464281 C1.95394085,29.8751251 2.31074136,29.9997309 2.67843679,30 C2.88525367,30 3.09006291,29.9594392 3.2810727,29.8801334 L6.86407797,28.4973212 C6.9874425,28.45043 7.12372204,28.45043 7.24708657,28.4973212 C8.65792419,29.0223211 10.126347,29.3008924 11.5177664,29.3008924 C13.251447,29.3025196 14.9641341,28.9215907 16.5337059,28.1852677 C16.899305,28.0138391 17.4711396,27.8276785 17.8059373,27.440625 C18.0649119,27.1337648 18.1162606,26.702142 17.9365084,26.3430806 Z"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisableTeleconsultIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/disable-teleconsult-icon.d1cf3806.svg";
export { ForwardRef as ReactComponent };